import _objectSpread from '@babel/runtime-corejs3/helpers/objectSpread2';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import { forwardRef } from 'react';
import { c as classNames } from '../../../shared/bind-56cf2a3b.js';
import { s as styles } from '../../../shared/Input-a5585d91.js';
import { getTestId } from '../../../utils/testId.js';
import { deprecationWarning } from '../../../utils/warning.js';
import { idFromName } from '../../../utils/html.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var cssClasses = classNames.bind(styles);
var Styling = /*#__PURE__*/function (Styling) {
  Styling["Tight"] = "tight";
  Styling["Narrow"] = "narrow";
  Styling["Wide"] = "wide";
  return Styling;
}(Styling || {});
var Theme = /*#__PURE__*/function (Theme) {
  Theme["Primary"] = "primary";
  return Theme;
}(Theme || {});
var Type = /*#__PURE__*/function (Type) {
  Type["Text"] = "text";
  Type["Password"] = "password";
  Type["Number"] = "number";
  Type["Email"] = "email";
  Type["Date"] = "date";
  Type["DateTimeLocal"] = "datetime-local";
  return Type;
}({});
var InputMode = /*#__PURE__*/function (InputMode) {
  InputMode["None"] = "none";
  InputMode["Decimal"] = "decimal";
  InputMode["Numeric"] = "numeric";
  InputMode["Telephone"] = "tel";
  InputMode["Search"] = "search";
  InputMode["Email"] = "email";
  InputMode["Url"] = "url";
  return InputMode;
}(InputMode || {});
var InputText = function InputText(_ref) {
  var name = _ref.name,
    validation = _ref.validation,
    title = _ref.title,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? Type.Text : _ref$type,
    required = _ref.required,
    disabled = _ref.disabled,
    min = _ref.min,
    max = _ref.max,
    step = _ref.step,
    maxLength = _ref.maxLength,
    defaultValue = _ref.defaultValue,
    suffix = _ref.suffix,
    placeholder = _ref.placeholder,
    autoComplete = _ref.autoComplete,
    readOnly = _ref.readOnly,
    styling = _ref.styling,
    theme = _ref.theme,
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur,
    onKeyDown = _ref.onKeyDown,
    onCopy = _ref.onCopy,
    onChange = _ref.onChange,
    forwardedRef = _ref.forwardedRef,
    value = _ref.value,
    testId = _ref.testId,
    inputMode = _ref.inputMode,
    aria = _ref.aria;
  var inputClass = cssClasses(styles.input, styling, theme);
  var inputValueClass = cssClasses(styles.value, _defineProperty({}, styles['with-suffix'], !!suffix));
  var AccessibleWrapper = title ? 'label' : 'div';
  return /*#__PURE__*/jsxs(AccessibleWrapper, {
    htmlFor: idFromName(name),
    className: inputClass,
    "data-testid": testId,
    children: [title ? /*#__PURE__*/jsx("div", {
      className: styles.title,
      "data-testid": getTestId(testId, 'title'),
      children: title
    }) : null, /*#__PURE__*/jsxs("div", {
      className: styles.content,
      children: [/*#__PURE__*/jsx("input", _objectSpread({
        className: inputValueClass,
        type: type,
        name: name,
        id: idFromName(name),
        value: value === null ? undefined : value,
        required: required,
        disabled: disabled,
        min: min,
        max: max,
        step: step,
        maxLength: maxLength,
        defaultValue: defaultValue,
        placeholder: placeholder,
        autoComplete: autoComplete,
        readOnly: readOnly,
        onChange: onChange,
        onFocus: onFocus,
        onBlur: onBlur,
        onCopy: onCopy,
        onKeyDown: onKeyDown,
        ref: forwardedRef,
        inputMode: inputMode,
        "data-testid": getTestId(testId, 'input')
      }, aria)), suffix ? /*#__PURE__*/jsx("div", {
        className: styles.suffix,
        children: suffix
      }) : null]
    }), validation ? /*#__PURE__*/jsx("div", {
      className: styles.note,
      children: validation
    }) : null]
  });
};
// BUG: default exports do not auto-generate storybook ArgsTable
// https://github.com/storybookjs/storybook/issues/9511
// remove export when resolved
var InputTextWithForwardedRef = /*#__PURE__*/forwardRef(function (props, ref) {
  var forwardedProps = _objectSpread({}, props);
  if (forwardedProps.deprecatedIcon) {
    forwardedProps.suffix = forwardedProps.suffix || forwardedProps.deprecatedIcon;
    deprecationWarning('Property icon on InputText component has been deprecated. Use property suffix instead');
  }
  return /*#__PURE__*/jsx(InputText, _objectSpread({
    forwardedRef: ref
  }, forwardedProps));
});
InputTextWithForwardedRef.displayName = InputText.name;
InputTextWithForwardedRef.Styling = Styling;
InputTextWithForwardedRef.Theme = Theme;
InputTextWithForwardedRef.Type = Type;
InputTextWithForwardedRef.InputMode = InputMode;

export { InputTextWithForwardedRef, Type, InputTextWithForwardedRef as default };
//# sourceMappingURL=InputText.js.map
